import React from 'react';

export default function Divider() {
  return <div className="mv8 bb b--default" />;
}
